// extracted by mini-css-extract-plugin
module.exports = {"container":"EditFormSummaryInstructionsModal_container__58e8H","modal":"EditFormSummaryInstructionsModal_modal__m9U6G","card":"EditFormSummaryInstructionsModal_card__OfySS"};